import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Home, CreditCard } from 'lucide-react';
import './SubscriptionCancel.css';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  const handleRetryUpgrade = () => {
    navigate('/', { replace: true });
    // Scroll to pricing section after navigation
    setTimeout(() => {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleGoHome = () => {
    navigate('/home');
  };



  return (
    <div className="subscription-cancel-container">
      <div className="subscription-cancel-card">
        <div className="cancel-icon">
          <X size={64} />
        </div>
        
        <h1>Upgrade Cancelled</h1>
        <p className="cancel-message">
          No worries! Your upgrade to Brainy AI Pro was cancelled and no payment was made. 
          You can continue using our free plan or upgrade anytime.
        </p>

        <div className="free-plan-reminder">
          <h3>What you still have with our Free plan:</h3>
          <ul>
            <li>✓ Personalized Learning Roadmap</li>
            <li>✓ 1 Educational goal</li>
            <li>✓ 1 Topic per goal</li>
            <li>✓ Notes management</li>
            <li>✓ 5 AI Chat Queries/day</li>
            <li>✓ Pomodoro Timer</li>
          </ul>
        </div>

        <div className="cancel-actions">
          <button 
            onClick={handleRetryUpgrade}
            className="primary-action-btn"
          >
            <CreditCard size={18} />
            Try Upgrade Again
          </button>
          
          <div className="secondary-actions">
            <button 
              onClick={handleGoHome}
              className="secondary-action-btn"
            >
              <Home size={18} />
              Go to Dashboard
            </button>
            

          </div>
        </div>

        <div className="help-section">
          <p>
            Need help deciding? <a href="mailto:support@secondbrainai.com">Contact our support team</a> or 
            check out our <a href="#" onClick={() => navigate('/')}>feature comparison</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel; 